import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export type LogoutLinkParams =
  /**
   * Logout Page
   * /logout
   */
  {
    page: 'logout';
    redirectPath?: string;
  };

export const getLinkForLogout = (params: LogoutLinkParams): ValidHref => {
  const pathname: ValidHref = `/logout`;
  const searchParams: { redirectPath?: string } = {};

  if ('redirectPath' in params && params.redirectPath) {
    searchParams.redirectPath = params.redirectPath;
  }

  return createUrl({
    pathname,
    searchParams,
  });
};

export const isLogoutPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  if (parts[1] === 'logout') {
    return true;
  }
  return false;
};
